import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ResponseLoginInterface } from '../../../@core/interfaces/auth.interface';
import {
  ResponseUserInterface,
  ResponseUsersInterface,
  UsersSearchInterface,
} from '../interfaces/user.inferfaces';
import { ResponseCounter } from '../../../@core/interfaces/general.interface';
import { UserInterface } from '../../../@core/interfaces/user.interface';
import { CustomHttpParamEncoder } from '../../../@core/decoder/custom.http.param.decoder';

const headers = new HttpHeaders({
  'Content-Type': 'application/json',
});

@Injectable({
  providedIn: 'root',
})
export class AdminUserService {
  constructor(public http: HttpClient) {}

  getAdminUsers(
    data: UsersSearchInterface
  ): Observable<ResponseUsersInterface> {
    let params = this.searchFilters(data, false);
    return this.http.get<ResponseUsersInterface>(
      environment.apiURL + `admin/users`,
      { params: params, headers: headers }
    );
  }

  getAdminUsersCounter(
    data: UsersSearchInterface
  ): Observable<ResponseCounter> {
    let params = this.searchFilters(data, false);
    return this.http.get<ResponseCounter>(
      environment.apiURL + `admin/users/count`,
      { params: params, headers: headers }
    );
  }

  getAdminUser(id: number): Observable<any> {
    return this.http.get<any>(environment.apiURL + `admin/users/${id}`, {
      headers: headers,
    });
  }

  changeStatusAdminUser(
    id: number,
    status: string
  ): Observable<ResponseUserInterface> {
    return this.http.put<ResponseUserInterface>(
      environment.apiURL + `admin/users/${id}`,
      { status },
      { headers: headers }
    );
  }

  editAdminUser(
    id: number,
    data: UserInterface
  ): Observable<ResponseUserInterface> {
    return this.http.put<ResponseUserInterface>(
      environment.apiURL + `admin/users/${id}`,
      data,
      { headers: headers }
    );
  }

  searchFilters(options: UsersSearchInterface, counter: boolean = false) {
    let params = new HttpParams({ encoder: new CustomHttpParamEncoder() });

    if (options) {
      if (options.keyword) {
        params = params.append('keyword', options.keyword);
      }

      if (options.status) {
        params = params.append('status', options.status);
      }

      if (options.id) {
        params = params.append('id', options.id);
      }

      if (options.email) {
        params = params.append('email', options.email);
      }

      if (options.role) {
        params = params.append('role', options.role);
      }

      if (options.firstName) {
        params = params.append('firstName', options.firstName);
      }

      if (options.lastName) {
        params = params.append('lastName', options.lastName);
      }

      if (options.caseNumber) {
        params = params.append('caseNumber', options.caseNumber);
      }

      if (options.courtName) {
        params = params.append('courtName', options.courtName);
      }

      if (options.routingNumber) {
        params = params.append('routingNumber', options.routingNumber);
      }

      if (options.accountNumber) {
        params = params.append('accountNumber', options.accountNumber);
      }

      if (!counter) {
        if (options.order) {
          params = params.append('order', options.order);
        }

        if (options && options.limit) {
          params = params.append('limit', options.limit);
        }

        if (options && (options.skip || options.skip === 0)) {
          params = params.append('skip', options.skip);
        }
      }
    }

    return params;
  }
}
